@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import androidx.compose.runtime.Composable
import androidx.compose.runtime.ProvidableCompositionLocal
import androidx.compose.runtime.compositionLocalOf
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Any
import kotlin.Suppress
import kotlin.Unit
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import dev.akshaychordiya.components.layouts.ArticleLayout as _dev_akshaychordiya_components_layouts_ArticleLayout
import dev.akshaychordiya.components.layouts.PageLayout as _dev_akshaychordiya_components_layouts_PageLayout
import dev.akshaychordiya.components.layouts.ProseLayout as _dev_akshaychordiya_components_layouts_ProseLayout
import dev.akshaychordiya.pages.AboutPage as _dev_akshaychordiya_pages_AboutPage
import dev.akshaychordiya.pages.AppsPage as _dev_akshaychordiya_pages_AppsPage
import dev.akshaychordiya.pages.ArticlesPage as _dev_akshaychordiya_pages_ArticlesPage
import dev.akshaychordiya.pages.BooksPage as _dev_akshaychordiya_pages_BooksPage
import dev.akshaychordiya.pages.HomePage as _dev_akshaychordiya_pages_HomePage
import dev.akshaychordiya.pages.NotFoundPage as _dev_akshaychordiya_pages_NotFoundPage
import dev.akshaychordiya.pages.TalksPage as _dev_akshaychordiya_pages_TalksPage
import dev.akshaychordiya.pages.articles.Android2017YearInReviewPage as _dev_akshaychordiya_pages_articles_Android2017YearInReviewPage
import dev.akshaychordiya.pages.articles.BuildComplexScreensFasterOnAndroidPage as _dev_akshaychordiya_pages_articles_BuildComplexScreensFasterOnAndroidPage
import dev.akshaychordiya.pages.articles.BuildingModernAppsUsingTheAndroidArchitectureGuidelinesPage as _dev_akshaychordiya_pages_articles_BuildingModernAppsUsingTheAndroidArchitectureGuidelinesPage
import dev.akshaychordiya.pages.articles.ExploringRoomArchitectureComponentPage as _dev_akshaychordiya_pages_articles_ExploringRoomArchitectureComponentPage
import dev.akshaychordiya.pages.articles.ExploringRoomArchitectureComponentTheExtrasPage as _dev_akshaychordiya_pages_articles_ExploringRoomArchitectureComponentTheExtrasPage
import dev.akshaychordiya.pages.articles.FileTemplateForRecyclerviewAdapterInKotlinPage as _dev_akshaychordiya_pages_articles_FileTemplateForRecyclerviewAdapterInKotlinPage
import dev.akshaychordiya.pages.articles.GoWithTheKotlinFlowPage as _dev_akshaychordiya_pages_articles_GoWithTheKotlinFlowPage
import dev.akshaychordiya.pages.articles.IntroducingOksseKotlinMultiplatformSseLibraryPage as _dev_akshaychordiya_pages_articles_IntroducingOksseKotlinMultiplatformSseLibraryPage
import dev.akshaychordiya.pages.articles.IntroducingPoseLibraryPage as _dev_akshaychordiya_pages_articles_IntroducingPoseLibraryPage
import dev.akshaychordiya.pages.articles.MagicalBookOfComposePerformanceDeferStateReadsPage as _dev_akshaychordiya_pages_articles_MagicalBookOfComposePerformanceDeferStateReadsPage
import dev.akshaychordiya.pages.articles.MigratingLegacyCodeToKotlinFlowPage as _dev_akshaychordiya_pages_articles_MigratingLegacyCodeToKotlinFlowPage

private val LayoutScopeLocal: ProvidableCompositionLocal<Any?> = compositionLocalOf<Any?> { null }

@Composable
private fun <T : Any> currentLayoutScope(): T {
    @Suppress("UNCHECKED_CAST")
    return LayoutScopeLocal.current as? T
        ?: error("Unexpected between Page/Layout scope and the parent Layout which it is providing it. Please report this issue to the Kobweb developers.")
}

@Composable
private fun <T : Any> provideLayoutScope(layoutScope: T, content: @Composable () -> Unit) {
    androidx.compose.runtime.CompositionLocalProvider(LayoutScopeLocal provides layoutScope, content = content)
}

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Akshay Chordiya"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.registerLayout(
            "dev.akshaychordiya.components.layouts.ArticleLayout",
            parentLayoutId = "dev.akshaychordiya.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                dev.akshaychordiya.components.layouts.initArticleLayout(ctx)
            },
        ) { pageCtx, pageMethod -> 
            _dev_akshaychordiya_components_layouts_ArticleLayout(pageCtx) {
                pageMethod(pageCtx)
            }
        }
        ctx.router.registerLayout(
            "dev.akshaychordiya.components.layouts.PageLayout",
        ) { pageCtx, pageMethod -> 
            _dev_akshaychordiya_components_layouts_PageLayout(pageCtx) {
                provideLayoutScope(this) {
                    pageMethod(pageCtx)
                }
            }
        }
        ctx.router.registerLayout(
            "dev.akshaychordiya.components.layouts.ProseLayout",
            parentLayoutId = "dev.akshaychordiya.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                dev.akshaychordiya.components.layouts.initProseLayout(ctx)
            },
        ) { pageCtx, pageMethod -> 
            _dev_akshaychordiya_components_layouts_ProseLayout {
                pageMethod(pageCtx)
            }
        }
        ctx.router.register(
            "/",
            layoutId = "dev.akshaychordiya.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                dev.akshaychordiya.pages.initHomePage(ctx)
            },
        ) { pageCtx -> 
            _dev_akshaychordiya_pages_HomePage()
        }
        ctx.router.register(
            "/about",
            layoutId = "dev.akshaychordiya.components.layouts.ProseLayout",
            initRouteMethod = { ctx ->
                dev.akshaychordiya.pages.initAboutPage(ctx)
            },
        ) { pageCtx -> 
            _dev_akshaychordiya_pages_AboutPage()
        }
        ctx.router.register(
            "/apps",
            layoutId = "dev.akshaychordiya.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                dev.akshaychordiya.pages.initAppsPage(ctx)
            },
        ) { pageCtx -> 
            _dev_akshaychordiya_pages_AppsPage()
        }
        ctx.router.register(
            "/articles",
            layoutId = "dev.akshaychordiya.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                dev.akshaychordiya.pages.initArticlesPage(ctx)
            },
        ) { pageCtx -> 
            _dev_akshaychordiya_pages_ArticlesPage()
        }
        ctx.router.register(
            "/articles/android2017-year-in-review",
            layoutId = "dev.akshaychordiya.components.layouts.ArticleLayout",
            initRouteMethod = { ctx ->
                dev.akshaychordiya.pages.articles.initAndroid2017YearInReviewPage(ctx)
            },
        ) { pageCtx -> 
            _dev_akshaychordiya_pages_articles_Android2017YearInReviewPage()
        }
        ctx.router.register(
            "/articles/build-complex-screens-faster-on-android",
            layoutId = "dev.akshaychordiya.components.layouts.ArticleLayout",
            initRouteMethod = { ctx ->
                dev.akshaychordiya.pages.articles.initBuildComplexScreensFasterOnAndroidPage(ctx)
            },
        ) { pageCtx -> 
            _dev_akshaychordiya_pages_articles_BuildComplexScreensFasterOnAndroidPage()
        }
        ctx.router.register(
            "/articles/building-modern-apps-using-the-android-architecture-guidelines",
            layoutId = "dev.akshaychordiya.components.layouts.ArticleLayout",
            initRouteMethod = { ctx ->
                dev.akshaychordiya.pages.articles.initBuildingModernAppsUsingTheAndroidArchitectureGuidelinesPage(ctx)
            },
        ) { pageCtx -> 
            _dev_akshaychordiya_pages_articles_BuildingModernAppsUsingTheAndroidArchitectureGuidelinesPage()
        }
        ctx.router.register(
            "/articles/exploring-room-architecture-component",
            layoutId = "dev.akshaychordiya.components.layouts.ArticleLayout",
            initRouteMethod = { ctx ->
                dev.akshaychordiya.pages.articles.initExploringRoomArchitectureComponentPage(ctx)
            },
        ) { pageCtx -> 
            _dev_akshaychordiya_pages_articles_ExploringRoomArchitectureComponentPage()
        }
        ctx.router.register(
            "/articles/exploring-room-architecture-component-the-extras",
            layoutId = "dev.akshaychordiya.components.layouts.ArticleLayout",
            initRouteMethod = { ctx ->
                dev.akshaychordiya.pages.articles.initExploringRoomArchitectureComponentTheExtrasPage(ctx)
            },
        ) { pageCtx -> 
            _dev_akshaychordiya_pages_articles_ExploringRoomArchitectureComponentTheExtrasPage()
        }
        ctx.router.register(
            "/articles/file-template-for-recyclerview-adapter-in-kotlin",
            layoutId = "dev.akshaychordiya.components.layouts.ArticleLayout",
            initRouteMethod = { ctx ->
                dev.akshaychordiya.pages.articles.initFileTemplateForRecyclerviewAdapterInKotlinPage(ctx)
            },
        ) { pageCtx -> 
            _dev_akshaychordiya_pages_articles_FileTemplateForRecyclerviewAdapterInKotlinPage()
        }
        ctx.router.register(
            "/articles/go-with-the-kotlin-flow",
            layoutId = "dev.akshaychordiya.components.layouts.ArticleLayout",
            initRouteMethod = { ctx ->
                dev.akshaychordiya.pages.articles.initGoWithTheKotlinFlowPage(ctx)
            },
        ) { pageCtx -> 
            _dev_akshaychordiya_pages_articles_GoWithTheKotlinFlowPage()
        }
        ctx.router.register(
            "/articles/introducing-oksse-kotlin-multiplatform-sse-library",
            layoutId = "dev.akshaychordiya.components.layouts.ArticleLayout",
            initRouteMethod = { ctx ->
                dev.akshaychordiya.pages.articles.initIntroducingOksseKotlinMultiplatformSseLibraryPage(ctx)
            },
        ) { pageCtx -> 
            _dev_akshaychordiya_pages_articles_IntroducingOksseKotlinMultiplatformSseLibraryPage()
        }
        ctx.router.register(
            "/articles/introducing-pose-library",
            layoutId = "dev.akshaychordiya.components.layouts.ArticleLayout",
            initRouteMethod = { ctx ->
                dev.akshaychordiya.pages.articles.initIntroducingPoseLibraryPage(ctx)
            },
        ) { pageCtx -> 
            _dev_akshaychordiya_pages_articles_IntroducingPoseLibraryPage()
        }
        ctx.router.register(
            "/articles/magical-book-of-compose-performance-defer-state-reads",
            layoutId = "dev.akshaychordiya.components.layouts.ArticleLayout",
            initRouteMethod = { ctx ->
                dev.akshaychordiya.pages.articles.initMagicalBookOfComposePerformanceDeferStateReadsPage(ctx)
            },
        ) { pageCtx -> 
            _dev_akshaychordiya_pages_articles_MagicalBookOfComposePerformanceDeferStateReadsPage()
        }
        ctx.router.register(
            "/articles/migrating-legacy-code-to-kotlin-flow",
            layoutId = "dev.akshaychordiya.components.layouts.ArticleLayout",
            initRouteMethod = { ctx ->
                dev.akshaychordiya.pages.articles.initMigratingLegacyCodeToKotlinFlowPage(ctx)
            },
        ) { pageCtx -> 
            _dev_akshaychordiya_pages_articles_MigratingLegacyCodeToKotlinFlowPage()
        }
        ctx.router.register(
            "/books",
            layoutId = "dev.akshaychordiya.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                dev.akshaychordiya.pages.initBooksPage(ctx)
            },
        ) { pageCtx -> 
            _dev_akshaychordiya_pages_BooksPage()
        }
        ctx.router.register(
            "/not-found",
            layoutId = "dev.akshaychordiya.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                dev.akshaychordiya.pages.initNotFoundPage(ctx)
            },
        ) { pageCtx -> 
            _dev_akshaychordiya_pages_NotFoundPage()
        }
        ctx.router.register(
            "/talks",
            layoutId = "dev.akshaychordiya.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                dev.akshaychordiya.pages.initTalksPage(ctx)
            },
        ) { pageCtx -> 
            _dev_akshaychordiya_pages_TalksPage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("headline-text", dev.akshaychordiya.HeadlineTextStyle)
        ctx.theme.registerStyle("subheadline-text", dev.akshaychordiya.SubheadlineTextStyle)
        ctx.theme.registerStyle("section-title", dev.akshaychordiya.SectionTitleStyle)
        ctx.theme.registerStyle("meta-text", dev.akshaychordiya.MetaTextStyle)
        ctx.theme.registerStyle("book-layout", dev.akshaychordiya.pages.BookLayoutStyle)
        ctx.theme.registerStyle("chip", dev.akshaychordiya.pages.ChipStyle)
        ctx.theme.registerStyle("chip-selected", dev.akshaychordiya.pages.ChipSelectedStyle)
        ctx.theme.registerStyle("talk-card", dev.akshaychordiya.pages.TalkCardStyle)
        ctx.theme.registerStyle("talk-layout", dev.akshaychordiya.pages.TalkLayoutStyle)
        ctx.theme.registerStyle("talk-link", dev.akshaychordiya.pages.TalkLinkStyle)
        ctx.theme.registerStyle("app-icon", dev.akshaychordiya.pages.AppIconStyle)
        ctx.theme.registerStyle("hero", dev.akshaychordiya.pages.HeroStyle)
        ctx.theme.registerStyle("avatar-box", dev.akshaychordiya.pages.AvatarBoxStyle)
        ctx.theme.registerStyle("avatar", dev.akshaychordiya.pages.AvatarStyle)
        ctx.theme.registerStyle("section-link", dev.akshaychordiya.pages.SectionLinkStyle)
        ctx.theme.registerStyle("callout", dev.akshaychordiya.pages.CalloutStyle)
        ctx.theme.registerStyle("callout-button", dev.akshaychordiya.pages.CalloutButtonStyle)
        ctx.theme.registerStyle("article-layout", dev.akshaychordiya.pages.ArticleLayoutStyle)
        ctx.theme.registerStyle("article-title", dev.akshaychordiya.pages.ArticleTitleStyle)
        ctx.theme.registerStyle("rss-pill", dev.akshaychordiya.pages.RssPillStyle)
        ctx.theme.registerStyle("search-input", dev.akshaychordiya.pages.SearchInputStyle)
        ctx.theme.registerStyle("interest-row", dev.akshaychordiya.components.widgets.InterestRowStyle)
        ctx.theme.registerStyle("interest-chip", dev.akshaychordiya.components.widgets.InterestChipStyle)
        ctx.theme.registerStyle("subscribe-box", dev.akshaychordiya.components.widgets.SubscribeBoxStyle)
        ctx.theme.registerStyle("subscribe-form", dev.akshaychordiya.components.widgets.SubscribeFormStyle)
        ctx.theme.registerStyle("subscribe-input", dev.akshaychordiya.components.widgets.SubscribeInputStyle)
        ctx.theme.registerStyle("subscribe-button", dev.akshaychordiya.components.widgets.SubscribeButtonStyle)
        ctx.theme.registerStyle("honeypot", dev.akshaychordiya.components.widgets.HoneypotStyle)
        ctx.theme.registerStyle("preview-frame", dev.akshaychordiya.components.widgets.PreviewFrameStyle)
        ctx.theme.registerStyle("preview-wide", dev.akshaychordiya.components.widgets.PreviewWideStyle)
        ctx.theme.registerStyle("preview-cover", dev.akshaychordiya.components.widgets.PreviewCoverStyle)
        ctx.theme.registerStyle("preview-image", dev.akshaychordiya.components.widgets.PreviewImageStyle)
        ctx.theme.registerStyle("portrait", dev.akshaychordiya.components.widgets.PortraitStyle)
        ctx.theme.registerStyle("list-row", dev.akshaychordiya.components.widgets.ListRowStyle)
        ctx.theme.registerStyle("card", dev.akshaychordiya.components.widgets.CardStyle)
        ctx.theme.registerStyle("world-map-land", dev.akshaychordiya.components.widgets.WorldMapLandStyle)
        ctx.theme.registerStyle("world-map", dev.akshaychordiya.components.widgets.WorldMapStyle)
        ctx.theme.registerStyle("page-content", dev.akshaychordiya.components.layouts.PageContentStyle)
        ctx.theme.registerStyle("wide-content", dev.akshaychordiya.components.layouts.WideContentStyle)
        ctx.theme.registerStyle("prose", dev.akshaychordiya.components.layouts.ProseStyle)
        ctx.theme.registerStyle("article-footer", dev.akshaychordiya.components.layouts.ArticleFooterStyle)
        ctx.theme.registerStyle("share-mount", dev.akshaychordiya.components.layouts.ShareMountStyle)
        ctx.theme.registerStyle("footer", dev.akshaychordiya.components.sections.FooterStyle)
        ctx.theme.registerStyle("footer-link", dev.akshaychordiya.components.sections.FooterLinkStyle)
        ctx.theme.registerStyle("nav-header", dev.akshaychordiya.components.sections.NavHeaderStyle)
        ctx.theme.registerStyle("wordmark", dev.akshaychordiya.components.sections.WordmarkStyle)
        ctx.theme.registerStyle("nav-link", dev.akshaychordiya.components.sections.NavLinkStyle)
        ctx.theme.registerStyle("nav-link-active", dev.akshaychordiya.components.sections.NavLinkActiveStyle)
        ctx.theme.registerVariant("-circle", dev.akshaychordiya.CircleButtonVariant)
        ctx.theme.registerVariant("-uncolored", dev.akshaychordiya.UncoloredButtonVariant)
        ctx.theme.registerKeyframes("fade-up", dev.akshaychordiya.FadeUpKeyframes)
        ctx.theme.registerKeyframes("fade-in", dev.akshaychordiya.FadeInKeyframes)
        ctx.theme.registerKeyframes("pop-in", dev.akshaychordiya.PopInKeyframes)
        ctx.theme.registerKeyframes("swap-in", dev.akshaychordiya.SwapInKeyframes)
        ctx.theme.registerKeyframes("pulse", dev.akshaychordiya.components.widgets.PulseKeyframes)
        ctx.theme.registerKeyframes("side-menu-slide-in", dev.akshaychordiya.components.sections.SideMenuSlideInAnim)
        dev.akshaychordiya.initSiteStyles(ctx)
        dev.akshaychordiya.initColorMode(ctx)
        dev.akshaychordiya.initTheme(ctx)
        dev.akshaychordiya.components.layouts.initClapStyles(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        dev.akshaychordiya.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
